/* src/app/shared/controls/modal/modal.component.scss */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.2);
  -webkit-backdrop-filter: blur(1.5px);
  backdrop-filter: blur(1.5px);
  z-index: 1000;
}
.modal-container {
  position: fixed;
  top: 50%;
  left: 50%;
  min-width: 20vw;
  max-height: 60vh;
  background: #fff;
  border-radius: 1.5rem 1.5rem 1.5rem 1.5rem;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.25);
  transform: translate(-50%, -50%);
  z-index: 1001;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  animation: modal-pop 0.8s cubic-bezier(0.4, 0, 0.2, 1);
}
.modal-header {
  padding: 1.5rem 1.5rem 0.5rem 2.5rem;
  border-top-left-radius: 1.5rem;
  border-top-right-radius: 1.5rem;
}
.modal-content {
  flex: 1;
  padding: 1rem 1.5rem;
  overflow-y: auto;
}
.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  padding: 0.5rem 1.5rem 1.5rem 1.5rem;
  border-bottom-left-radius: 1.5rem;
  border-bottom-right-radius: 1.5rem;
}
@keyframes modal-pop {
  0% {
    opacity: 0;
    transform: translate(-50%, -50%) scale(0.5);
  }
  80% {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1.05);
  }
  100% {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1);
  }
}
/*# sourceMappingURL=modal.component-B7T6I7YG.css.map */
